import qs from "qs";
export default function(input = {}) {
    // 将日期转为 unixtimestamp
    // 其他的使用 qs 直接转化
    const params = {};
    let hasFile = false;
    Object.keys(input).forEach(key => {
        const val = input[key];
        switch (true) {
            case val instanceof File:
            case val instanceof FileList:
                hasFile = true; // 如果有文件，我们用 FormData
                break;
            case val instanceof Date: // 日期转 unixtimestamp
                return (params[key] = ~~(+val / 1000));
            case Array.isArray(val): {
                // 简单的数组（一维，string or number) 可以直接交给 qs 来转
                const isSimple = !val.filter(one => "object" === typeof one).length;
                if (isSimple) {
                    break;
                    // } else {
                    //     return params[key] = JSON.stringify(val);
                    // }
                }
                return (params[key] = JSON.stringify(val));
            }
            case "object" === typeof val && val !== null: // 将 obj 转为 json
                return (params[key] = JSON.stringify(val));
        }
        params[key] = val;
    });
    let result;
    if (hasFile) {
        result = new FormData();
        Object.keys(params).forEach(key => {
            const val = params[key];
            // 数组是前面的漏网之鱼
            result.append(key, Array.isArray(val) ? JSON.stringify(val) : val);
        });
    } else {
        result = qs.stringify(params, { arrayFormat: "brackets" });
    }
    return result;
}
